<div class="flex justify-between items-center mb-3">
  <h1 class="headeradminui-text">Manage Master Data</h1>
  <button nz-button nzType="primary" (click)="openDrawer()">Add Data</button>
</div>
<nz-spin [nzSpinning]="tableLoading" nzTip="Fetching data......">
  <nz-table
    #basicTable
    [nzData]="list"
    [nzBordered]="true"
    [nzShowPagination]="false"
    [nzScroll]="{ y: '500px' }"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th>Data</th>
        <th
          *ngFor="let key of filteredKeys; trackBy: trackByKey"
          [nzWidth]="
            isArrayColumn(key) ? '250px' : isColorColumn(key) ? '120px' : null
          "
        >
          {{ key }}
        </th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of list; trackBy: trackByRow">
        <td>
          <ng-container *ngIf="isUrl(row.data); else plainData">
            <ng-container *ngIf="isSvgPreview(row.data); else rasterData">
              <span
                *ngIf="getSvgPreview(row.data); else svgPending"
                class="svg-inline"
                [innerHTML]="getSvgPreview(row.data)"
              ></span>
            </ng-container>
            <ng-template #rasterData>
              <img
                [src]="mediaUrl(row.data)"
                alt="image"
                style="max-height: 48px"
              />
            </ng-template>
          </ng-container>
          <ng-template #plainData>{{ row.data }}</ng-template>
          <ng-template #svgPending>—</ng-template>
        </td>
        <td *ngFor="let key of filteredKeys; trackBy: trackByKey">
          <!-- arrays: map and show; if values are urls show images -->
          <ng-container [ngSwitch]="cellType(key, row[key])">
            <ng-container *ngSwitchCase="'color'">
              <div *ngIf="formatValue(row[key]); else noColor" class="color-cell">
                <span
                  class="color-swatch"
                  [style.background-color]="colorValue(row[key])"
                ></span>
                <span>{{ formatValue(row[key]) }}</span>
              </div>
              <ng-template #noColor>—</ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'images'">
              <div class="flex gap-2 flex-wrap">
                <ng-container *ngFor="let v of toArray(row[key])">
                  <span
                    *ngIf="isSvgPreview(v); else rasterArrayImg"
                  >
                    <span
                      *ngIf="getSvgPreview(v); else svgPending"
                      class="svg-inline"
                      [innerHTML]="getSvgPreview(v)"
                    ></span>
                    <ng-template #svgPending>—</ng-template>
                  </span>
                  <ng-template #rasterArrayImg>
                    <img
                      [src]="mediaUrl(v)"
                      alt="image"
                      style="max-height: 32px"
                    />
                  </ng-template>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'svg'">
              <span
                *ngIf="getSvgPreview(row[key]); else svgPendingCell"
                class="svg-inline"
                [innerHTML]="getSvgPreview(row[key])"
              ></span>
              <ng-template #svgPendingCell>—</ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'image'">
              <img
                [src]="mediaUrl(row[key])"
                alt="image"
                style="max-height: 32px"
              />
            </ng-container>
            <ng-container *ngSwitchCase="'array'">
              <nz-tag
                *ngFor="let v of toArray(row[key]); trackBy: trackByIndex"
                [nzColor]="'blue'"
              >
                {{ formatValue(v) }}
              </nz-tag>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ formatValue(row[key]) }}
            </ng-container>
          </ng-container>
        </td>
        <td>
          <button nz-button nzSize="small" (click)="editItem(row)">Edit</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>

<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzClosable]="true"
  [nzWidth]="600"
  (nzOnClose)="closeDrawer()"
  nzTitle="Add Data"
  [nzFooter]="footer"
>
  <ng-template #footer>
    <div class="flex justify-end gap-2 mt-4">
      <button nz-button type="button" (click)="closeDrawer()">Cancel</button>
      <button
        nz-button
        nzType="primary"
        type="button"
        [disabled]="isSubmitting"
        (click)="submit()"
      >
        {{ isSubmitting ? "Saving..." : "Save" }}
      </button>
    </div>
  </ng-template>

  <ng-container *nzDrawerContent>
    <form [formGroup]="form" class="flex flex-col gap-3">
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzRequired>Category</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input nz-input [value]="category" disabled />
        </nz-form-control>
      </nz-form-item>

      <div formArrayName="fields" class="flex flex-col gap-3">
        <div
          *ngFor="
            let fg of fields.controls;
            let i = index;
            trackBy: trackByIndex
          "
          [formGroupName]="i"
          class="rounded border p-3 flex flex-col gap-2"
        >
          <div class="font-medium">{{ fg.get("key")!.value }}</div>

          <ng-container [ngSwitch]="fg.get('fieldType')!.value">
            <ng-container *ngSwitchCase="'textbox'">
              <input
                nz-input
                formControlName="value"
                [type]="
                  fg.get('dataType')!.value === 'number' ? 'number' : 'text'
                "
              />
            </ng-container>

            <ng-container *ngSwitchCase="'switch'">
              <nz-switch formControlName="value"></nz-switch>
            </ng-container>

            <ng-container *ngSwitchCase="'dropdown'">
              <nz-select
                formControlName="value"
                [nzMode]="
                  fg.get('dataType')!.value === 'StringArray'
                    ? 'multiple'
                    : 'default'
                "
                nzPlaceHolder="Select"
              >
                <nz-option
                  *ngFor="let opt of fieldOptions[i] || []"
                  [nzLabel]="opt.data"
                  [nzValue]="opt.value"
                ></nz-option>
              </nz-select>
            </ng-container>

            <ng-container *ngSwitchCase="'file_picker'">
              <input type="file" (change)="onFile($event, i)" />
              <div
                class="mt-2"
                *ngIf="fg.get('value')!.value || previewUrls[i]"
              >
                <ng-container
                  *ngIf="
                    showSvgPreview(i, fg.get('value')!.value);
                    else rasterPreview
                  "
                >
                  <span
                    *ngIf="
                      getSvgPreview(svgPreviewSource(i, fg.get('value')!.value));
                      else svgDrawerPending
                    "
                    class="svg-inline svg-inline--lg"
                    [innerHTML]="
                      getSvgPreview(svgPreviewSource(i, fg.get('value')!.value))
                    "
                  ></span>
                  <ng-template #svgDrawerPending>—</ng-template>
                </ng-container>
                <ng-template #rasterPreview>
                  <img
                    [src]="previewUrls[i] || fg.get('value')!.value"
                    alt="preview"
                    style="max-height: 64px"
                  />
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'color_picker'">
              <input type="color" formControlName="value" />
            </ng-container>
          </ng-container>
        </div>
      </div>
    </form>
  </ng-container>
</nz-drawer>
